<div class="flex pt-8 justify-center bg-gray-100 pb-10 px-4 min-h-screen">
  <div class=" rounded-2xl w-full md:w-2/3 bg-white shadow-lg">
    <div class="flex flex-col items-stretch px-5 md:px-10 mt-5 gap-5" @inOutAnimation *ngIf="powerPlant; else loading">
      <psc-result-title
        @inOutAnimation
        [title]="recalculated ? ('title.user.unsaved-plant' | transloco) : powerPlant.projectName"
        [calculationResultWrapper]="resultWrapper"
        [powerPlant]="powerPlant"
        [hideSavePlant]="true"
        [advancedPdfDownload]="powerPlant.price.type === PriceType.ENTERPRISE || powerPlant.paymentStatus === PaymentStatus.SUCCEEDED"
        class="w-full">
        <psc-button
          *ngIf="recalculated"
          (buttonClicked)="updatePowerPlant()"
          [label]="'update-power-plant' | transloco">
        </psc-button>
      </psc-result-title>

      <psc-basic-power-plant-info class="w-full" [powerPlant]="powerPlant"></psc-basic-power-plant-info>
      <ng-container
        *ngIf="powerPlant.price.type === PriceType.ENTERPRISE || powerPlant.paymentStatus === PaymentStatus.SUCCEEDED || ([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS, UserRole.ROLE_BUSINESS_PLUS_EXP, UserRole.ROLE_BUSINESS_EXP] | userHasRole); else basicResult">
        <psc-advanced-solar-calculation-result
          @inOutAnimation
          [showRecalculate]="false"
          [powerPlant]="powerPlant"
          [solarCalculatorResultWrapper]="resultWrapper"></psc-advanced-solar-calculation-result>

        <psc-recalculate
          (recalculate)="plantRecalculated($event)"
          [solarCalculatorResult]="resultWrapper.result"></psc-recalculate>
      </ng-container>
      <ng-template #basicResult>
        <psc-basic-solar-calculation-result
          @inOutAnimation
          [powerPlant]="powerPlant"
          [calculatorResultWrapper]="resultWrapper"></psc-basic-solar-calculation-result>
      </ng-template>

    </div>
    <ng-template #loading>
      <div class="w-full h-full pt-5 flex justify-center">
        <psc-loader></psc-loader>
      </div>
    </ng-template>

  </div>
</div>
